import { render, staticRenderFns } from "./SelectProduct.vue?vue&type=template&id=395b7d43&scoped=true&"
import script from "./SelectProduct.vue?vue&type=script&lang=js&"
export * from "./SelectProduct.vue?vue&type=script&lang=js&"
import style0 from "./SelectProduct.vue?vue&type=style&index=0&id=395b7d43&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395b7d43",
  null
  
)

export default component.exports